import { ISSUE_API_ROOT } from '../constants';

const STATUS_AUDIT_ACTIVITY_TYPES = ['CREATED', 'STATUS_CHANGED'];
const DATA_AUDIT_ACTIVITY_TYPES = [
  'UPDATED',
  'ASSIGNEE_CHANGED',
  'COMMENT_ADDED',
  'COMMENT_EDITED',
  'ATTACHMENT_ADDED',
];
const AUDITED_ACTIVITY_TYPES = [
  ...STATUS_AUDIT_ACTIVITY_TYPES,
  ...DATA_AUDIT_ACTIVITY_TYPES,
];

export const ACTIVITY_TAB_FILTERS = {
  STATUS_AUDIT: {
    includeActivityTypes: STATUS_AUDIT_ACTIVITY_TYPES.join(','),
  },
  AUDIT_DATA: {
    includeActivityTypes: DATA_AUDIT_ACTIVITY_TYPES.join(','),
  },
  EVENT_FEED: {
    excludeActivityTypes: AUDITED_ACTIVITY_TYPES.join(','),
  },
};

export const buildActivityListApiUrl = ({
  baseApiUrl,
  issueId,
  includeActivityTypes,
  excludeActivityTypes,
}) => {
  const apiUrl = new URL(`${baseApiUrl}${ISSUE_API_ROOT}/activity`);
  apiUrl.searchParams.set('issueId', issueId);

  if (includeActivityTypes) {
    apiUrl.searchParams.set('includeActivityTypes', includeActivityTypes);
  }

  if (excludeActivityTypes) {
    apiUrl.searchParams.set('excludeActivityTypes', excludeActivityTypes);
  }

  return apiUrl.href;
};
